import { TextProps } from '@mantine/core';
import { formatCurrencyEnUs } from '@zorro/shared/formatters';
import { Text } from '@zorro/web/design-system';

type Props = TextProps & {
  children?: number;
};

export const EnrollmentReviewCardCurrency = ({
  children = 0,
  ...props
}: Props) => {
  const formatted = formatCurrencyEnUs(children, { minimumFractionDigits: 2 });
  const decimalSeparatorIndex = formatted.lastIndexOf('.');
  if (decimalSeparatorIndex === -1) return formatted;
  return (
    <Text w="100%" ta="right" {...props}>
      {formatted.slice(0, decimalSeparatorIndex)}
      <Text component="span" size="xs" fw="inherit" c="inherit">
        {formatted.slice(decimalSeparatorIndex)}
      </Text>
    </Text>
  );
};
